import React from 'react'
import { reduxForm, Field } from 'redux-form'

import WrappedInput from '../Shared/Forms/WrappedInput'
import Button from '../Shared/Button'
import Card from '../Shared/Card'
import FormError from '../Shared/Forms/FormError'
import { validateEmail } from './validations'

const FORM_NAME = 'signupForm'

const validate = data => {
  const errors = {}

  if (!data.email) {
    errors.email = 'Please enter your work email'
  }

  if (!data.name) {
    errors.name = 'Please enter your full name'
  }

  if (!data.password) {
    errors.password = 'Please pick a password'
  }

  if (!data.organizationName) {
    errors.organizationName = 'Please enter your company name'
  }

  return errors
}

const Form = function SignupForm({
  handleSubmit,
  submitting,
  error,
  invitation,
}) {
  return (
    <form onSubmit={handleSubmit}>
      <Card actions={<Button loading={submitting}>Signup</Button>}>
        <h1>Signup</h1>
        {!invitation && (
          <p className="subtitle">
            Get started automating your support tasks tasks in minutes.
          </p>
        )}
        <Field
          name="email"
          placeholder="Work Email"
          type="email"
          component={WrappedInput}
          disabled={invitation}
        />
        <Field
          name="password"
          placeholder="Password"
          type="password"
          component={WrappedInput}
        />
        <Field
          name="name"
          placeholder="Full Name"
          type="text"
          component={WrappedInput}
        />
        {!invitation && (
          <Field
            name="organizationName"
            placeholder="Company Name"
            type="text"
            component={WrappedInput}
          />
        )}
        {error && <FormError>{error}</FormError>}
      </Card>
    </form>
  )
}

export default reduxForm({
  form: FORM_NAME,
  validate,
  asyncValidate: validateEmail,
})(Form)
